import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'What countries does TrackVerse operate in?',
      answer: 'TrackVerse operates in over 50 countries across Europe, America, Africa, Asia, and Oceania. Our extensive global network ensures reliable logistics solutions wherever your business needs them.',
    },
    {
      question: 'How can I track my shipment?',
      answer: 'You can track your shipment in real-time using our tracking page. Simply enter your tracking number (format: TRV-YYYY-XXXX) to view detailed information about your package location, status, and estimated delivery time.',
    },
    {
      question: 'What types of cargo can you handle?',
      answer: 'We handle all types of cargo including standard containers, oversized freight, temperature-controlled goods, dangerous goods (with proper documentation), and bulk shipments across ocean, air, road, and rail transport modes.',
    },
    {
      question: 'Do you provide customs clearance services?',
      answer: 'Yes, we offer comprehensive customs clearance services including documentation preparation, duty and tax calculation, tariff classification, and compliance consulting to ensure smooth international shipments.',
    },
    {
      question: 'What are your shipping rates?',
      answer: 'Our rates vary based on service type, cargo size, weight, destination, and urgency. Ocean freight starts from $500 per container, air freight from $5 per kg, road transport from $200 per shipment, and rail logistics from $400 per container. Contact us for a detailed quote.',
    },
    {
      question: 'How long does international shipping take?',
      answer: 'Transit times vary by service: Ocean freight typically takes 15-45 days, air freight 2-7 days, road transport 1-10 days within Europe, and rail logistics 10-20 days for Europe-Asia routes. We provide estimated delivery dates for all shipments.',
    },
    {
      question: 'Do you offer insurance for shipments?',
      answer: 'Yes, we offer comprehensive cargo insurance options to protect your shipments against loss, damage, or delays. Insurance coverage can be customized based on your cargo value and risk assessment.',
    },
    {
      question: 'Can I schedule a consultation with your team?',
      answer: 'Absolutely! You can schedule a consultation by filling out our contact form, emailing us at info.trackverse@gmail.com, or visiting our office during business hours (Monday-Saturday, 8 AM - 7 PM). We\'re here to help with all your logistics needs.',
    },
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="font-serif text-5xl lg:text-6xl text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-600">
            Find answers to common questions about our services
          </p>
        </motion.div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.05 }}
              className="bg-white rounded-2xl shadow-md overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left hover:bg-gray-50 transition-colors"
              >
                <span className="font-semibold text-gray-900 text-lg pr-4">{faq.question}</span>
                <i
                  className={`${
                    openIndex === index ? 'ri-subtract-line' : 'ri-add-line'
                  } text-2xl text-primary-blue flex-shrink-0 transition-transform`}
                ></i>
              </button>
              <AnimatePresence>
                {openIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="overflow-hidden"
                  >
                    <div className="px-8 pb-6 text-gray-600 leading-relaxed">{faq.answer}</div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;